import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/widgets/accordion'
import $ from 'jquery'

class ShowMore {
  constructor(element) {
    if (!element) {
      return false
    }

    this.element = element
    this.wrap = $(element)

    this.iniVars()

    if (this.showMore) {
      this.hideItems()
      this.toggle()
    }
  }

  iniVars() {
    this.items = this.wrap.find('.s-download-doc__items li')
    this.hiddenItems = this.wrap.find('.s-download-doc__items > ul > li.hidden')
    this.btn = this.wrap.find('.s-download-doc__toggle')
    this.showMore = this.wrap.data('showmore')
    this.more = this.wrap.data('showmorelabel')
    this.less = this.wrap.data('showlesslabel')
  }

  hideItems() {
    this.wrap.addClass('s-download-doc--show-more')
    //  this.items.slice(4).addClass('hidden')
  }

  toggle() {
    this.btn.on('click', (e) => {
      this.wrap.toggleClass('s-download-doc--show-more')
      this.wrap
        .find('.s-download-doc__toggle')
        .text(
          this.wrap.hasClass('s-download-doc--show-more')
            ? this.more
            : this.less
        )      
       
    })
  }
}
export default ShowMore
